import { Accordion, InputField } from '@ubeya/shared-web/components';
import React, { useContext } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { FieldsContainer, SectionContent } from '../styled';
import RegisteredNameForInvoicingField from './RegisteredNameForInvoicingField';

const ClientDetails = () => {
  const { t } = useContext(ConfigContext);

  return (
    <Accordion defaultOpenRows={{ 0: true }}>
      <Accordion.Item title={t('invoicingSettings__generalDetails')}>
        <SectionContent>
          <FieldsContainer $count={2}>
            <RegisteredNameForInvoicingField />
            <InputField name="invoicing.businessId" title={t('invoicingSettings__businessId')} />
            <InputField name="invoicing.website" title={t('invoicingSettings__website')} />
            <InputField name="invoicing.address1" title={t('invoicingSettings__address1')} />
            <InputField name="invoicing.address2" title={t('invoicingSettings__address2')} />
            <InputField name="invoicing.address3" title={t('invoicingSettings__address3')} />
          </FieldsContainer>
        </SectionContent>
      </Accordion.Item>
    </Accordion>
  );
};

export default ClientDetails;
